import { render, staticRenderFns } from "./type-title.vue?vue&type=template&id=5e1fcebd&scoped=true&"
import script from "./type-title.vue?vue&type=script&lang=js&"
export * from "./type-title.vue?vue&type=script&lang=js&"
import style0 from "./type-title.vue?vue&type=style&index=0&id=5e1fcebd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1fcebd",
  null
  
)

export default component.exports